/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Copyright All Rights Reserved
 */

import Rollbar from 'rollbar';

const rollbarInit = (enabled, environment, accessToken) => {
  const rollbarConfig = {
    accessToken,
    captureUncaught: true,
    enabled,
    payload: {
      environment,
    },
  };
  return Rollbar.init(rollbarConfig);
};

export default rollbarInit;



// WEBPACK FOOTER //
// ./js/support/rollbarInit.js